"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TabletRenderer_1 = __importDefault(require("./TabletRenderer"));
var tabletUtils_1 = require("./tabletUtils");
var TabletLineNumRenderer = (function (_super) {
    __extends(TabletLineNumRenderer, _super);
    function TabletLineNumRenderer(renderer) {
        var _this = _super.call(this, renderer.getEpigraphicUnits(), renderer.getLocale(), renderer.getRendererType()) || this;
        _this.renderer = null;
        _this.renderer = renderer;
        return _this;
    }
    TabletLineNumRenderer.prototype.lineReading = function (lineNum) {
        if (this.renderer) {
            var reading = this.renderer.lineReading(lineNum);
            var isRegion = this.renderer.isRegion(lineNum);
            var isUndetermined = this.renderer.isUndetermined(lineNum);
            if (isRegion || isUndetermined) {
                return reading;
            }
            var lineNumber = (0, tabletUtils_1.formatLineNumber)(lineNum);
            return reading
                ? (0, tabletUtils_1.localizeString)("".concat(lineNumber, " ").concat(reading), this.locale)
                : '';
        }
        throw new Error('Undefined renderer passed to render decorator');
    };
    return TabletLineNumRenderer;
}(TabletRenderer_1.default));
exports.default = TabletLineNumRenderer;
//# sourceMappingURL=TabletLineNumRenderer.js.map